export default [
  {
    path: '/receber',
    name: 'receber',
    component: () => import(/* webpackChunkName: "receber" */ './Receber.vue')
  }
]
